import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { ToastController, Platform, AlertController, LoadingController } from '@ionic/angular';
import { BehaviorSubject, defer, from, Observable, of } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
import { Console } from 'node:console';
import { EventService } from './event.service';


const TOKEN_KEY = 'auth-token';
const USER_ID = 'user-id';
const SYNUID = 'synuid';
/** ==================QA=======================
  * Sign-on url https://dgkr-dev.syngentadigitalapps.com/
 * Reply url: - https://dgkr-dev.syngentadigitalapps.com/
 * tenant: '06219a4a-a835-44d5-afaf-3926343bfb89',
 * clientId: '851ce147-6c9b-44f2-a4a0-0317fcda6fdf', */

/** ==================DEV=======================
 * Sign-on url https://dgkr-dev.syngentadigitalapps.com/
 * Reply url: - https://dgkr-dev.syngentadigitalapps.com/
 * tenant: '06219a4a-a835-44d5-afaf-3926343bfb89',
 * clientId: '851ce147-6c9b-44f2-a4a0-0317fcda6fdf', */

/** ==================PROD=======================
 * Sign-on url https://dgkr.syngentadigitalapps.com
 * Reply url: - https://dgkr.syngentadigitalapps.com
 * tenant: '06219a4a-a835-44d5-afaf-3926343bfb89',
 * clientId: '4d4f8480-c868-43e9-b6e5-f9213cad7294', */

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  // private adalConfig = {
  //   tenant: '06219a4a-a835-44d5-afaf-3926343bfb89',
  //  clientId: '851ce147-6c9b-44f2-a4a0-0317fcda6fdf', //DEV
  //  // clientId:'4d4f8480-c868-43e9-b6e5-f9213cad7294', //PROD
  //   redirectUri: window.location.origin + '/',
  //   postLogoutRedirectUri: window.location.origin + '/',
  //   endpoints: {
  //     "[HOME_URL_WEB_API]": "[HOME_WEB_API_GUID]"
  //   }
  // }

  authenticationState = new BehaviorSubject(false);
  constructor(private storage: StorageService,private loadingController:LoadingController, private plt: Platform, private msal: MsalService,private alertController: AlertController,private event :EventService) {

    // this.adal.instance.in(this.adalConfig);
    this.plt.ready().then(() => {
      this.checkToken();
    })
  }

  checkToken() {
    this.storage.get(TOKEN_KEY).then(res => {
      if (res) {
        this.authenticationState.next(true);
      }
    })
  }

  login() {
    console.log('login called')
    this.msal.loginRedirect()
    
  }

  logout() {
    this.removeToken();
    this.msal.logout();
  }

  isAuthenticated() {
    if (this.msal.instance.getAllAccounts().length > 0) {
      return true
    } else {
      return false;
    }
  }

  saveToken() {
    this.storage.set(SYNUID, this.msal.instance.getActiveAccount().username).then(() => {
    })
    return this.msal.instance.ssoSilent(environment.adalConfig).then(data => {
      return this.storage.set(TOKEN_KEY, 'Bearer ' + data.accessToken).then(() => {
        this.authenticationState.next(true);
      });
    });

  }

  removeToken() {
    localStorage.clear();
    return this.storage.remove(TOKEN_KEY).then(() => {
      this.authenticationState.next(false);
    });
  }

  isUserAuthenticated() {
  console.log('ACQUIRE TOKEN SILENT CALLED')
  this.msal.instance.handleRedirectPromise().then(res=>{
    if(res!=null && res.account != null){
      this.msal.instance.setActiveAccount(res.account);
      this.msal.instance.acquireTokenSilent(environment.adalConfig).then(data => {
        this.hideGlobalLoader();
        this.storage.set(SYNUID, data.account.username).then(() => {
        })
        localStorage.setItem('accessToken', 'Bearer ' + data.accessToken);
        this.authenticationState.next(true);
        this.storage.set(TOKEN_KEY, 'Bearer ' + data.accessToken).then(() => {
          //window.alert('=== FRESH TOKEN ===,,Authentication service')
           
        });
      }).catch(err => {
        console.log('testttt')
        this.hideGlobalLoader();
         this.showAlert(err);
      });
    }
   })
   
  }

  async hideGlobalLoader() {
    try {
      const element = await this.loadingController.getTop();
      if (element != null) {
        this.loadingController.dismiss();
        return;
      }
    } catch (error) {
    }
  }

  async showAlert(err){
    const alert = await this.alertController.create({
      header: 'Session!',
      message: 'Session Expired , Please click on Ok to continue ',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            if (err instanceof InteractionRequiredAuthError) {
              this.msal.instance.acquireTokenRedirect(environment.adalConfig);
            } else if (err instanceof BrowserAuthError) {
              //this.logout();
              this.msal.instance.loginRedirect(environment.adalConfig);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  refreshToken() : Observable<any>{
    return defer(()=>{
      return this.msal.instance.acquireTokenSilent(environment.adalConfig).then(data=>{
        localStorage.setItem('accessToken', 'Bearer ' + data.accessToken);
        return data;
      },error=>{
          this.hideGlobalLoader();
          this.showAlert(error);
      })
    });
    
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
   
  }

}
